import React, { useEffect, useRef } from 'react';

export const LogoCarousel = ({ logos = [], scrollSpeed = 50 }) => {
  const scrollRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!scrollRef.current || logos.length === 0) return;
    let scrollPosition = 0;
    const scroll = () => {
      if (scrollRef.current) {
        scrollPosition += scrollSpeed / 60;
        const maxScroll = scrollRef.current.scrollWidth / 2;
        if (scrollPosition >= maxScroll) scrollPosition = 0;
        scrollRef.current.scrollLeft = scrollPosition;
      }
      animationRef.current = requestAnimationFrame(scroll);
    };
    animationRef.current = requestAnimationFrame(scroll);
    return () => { if (animationRef.current) cancelAnimationFrame(animationRef.current); };
  }, [logos, scrollSpeed]);

  if (!logos || logos.length === 0) return null;
  const duplicatedLogos = [...logos, ...logos];

  return (
    <div className="overflow-hidden" data-testid="logo-carousel">
      <div ref={scrollRef} className="hidden md:flex items-center gap-10 overflow-x-hidden py-4" style={{ scrollbarWidth: 'none' }}>
        <div className="flex items-center gap-10" style={{ width: 'max-content' }}>
          {duplicatedLogos.map((logo, index) => (
            <a key={index} href={logo.linkUrl || '#'} className="flex-shrink-0 flex items-center justify-center w-28 h-16 bg-white rounded-lg p-3 opacity-50 hover:opacity-100 transition-all grayscale hover:grayscale-0" aria-label={logo.name}>
              <img src={logo.imageUrl} alt={logo.name} className="max-w-full max-h-full object-contain" loading="lazy" width="112" height="64" />
            </a>
          ))}
        </div>
      </div>
      <div className="md:hidden overflow-x-auto scrollbar-hide py-4">
        <div className="flex items-center gap-4 px-2" style={{ width: 'max-content' }}>
          {logos.map((logo, index) => (
            <a key={index} href={logo.linkUrl || '#'} className="flex-shrink-0 flex items-center justify-center w-24 h-14 bg-white rounded-lg p-2 opacity-50 grayscale" aria-label={logo.name}>
              <img src={logo.imageUrl} alt={logo.name} className="max-w-full max-h-full object-contain" loading="lazy" width="96" height="56" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
